export default __webpack_public_path__ + "static/media/delete.5256d002.png";